export const LINKEDIN_SHARE_URL = "https://www.linkedin.com/sharing/share-offsite/";